import React from 'react';
import styles from './GeoBlock.css';
import { IGeoLabel } from '../../types/geo';
import { GeoLabel } from './GeoLabel';
import { ContentRow } from '../ContentRow';

interface IGeoBlockProps {
  geoLabels: IGeoLabel[];
  geoExtensionLabel?: React.ReactNode;
  seoSuggestion?: React.ReactNode;
  onLabelClick(label: string): void;
}

export const GeoBlock: React.FC<IGeoBlockProps> = ({
  onLabelClick,
  geoLabels,
  geoExtensionLabel,
  seoSuggestion,
  children,
}) => {
  return (
    <ContentRow size={'L'}>
      {children}
      <div className={styles['labels']}>
        {geoLabels.map((label, index) => {
          const item = <GeoLabel key={`offer-card-geo-${label.url}`} {...label} onLabelClick={onLabelClick} />;

          return [index > 0 && ', ', item];
        })}
        {seoSuggestion}
      </div>

      {geoExtensionLabel}
    </ContentRow>
  );
};
